import React, { MouseEvent } from 'react';

import { themes } from 'kb-shared';
import styled, { css } from 'styled-components';

type Props = {
  type?: string;
  buttons: Array<{ text?: string; onClick?: (e: MouseEvent) => void; color?: string }>;
  children: React.ReactNode;
};

export const Card: React.FC<Props> = ({ type, buttons, children }) => {
  const renderButtons = () => {
    return buttons.map((button, index) => {
      return (
        <Button
          tabIndex={0}
          key={`${button.text} + ${index}`}
          onClick={button.onClick}
          color={button.color}
        >
          {button.text}
        </Button>
      );
    });
  };

  return (
    <Container type={type}>
      {children}
      <ButtonContainer>{renderButtons()}</ButtonContainer>
    </Container>
  );
};

//#region Styles
interface ContainerProps {
  type?: string;
}

const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;

  ${props =>
    props.type === 'mobile-no-padding' &&
    css`
      @media screen and ${themes.queries.mobile} {
        padding-left: 0;
        padding-right: 0;
      }
    `}
`;

const Button = styled.a`
  cursor: pointer;
  height: 48px;
  box-shadow: 0 2px 8px 0 #ababab;
  border-radius: 24px;
  background-color: ${props => (props.color ? props.color : themes.colors.yellow.lightestYellow)};
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 12px 0px 12px 0px;
  padding: 0px 20px;
  &:hover {
    background-color: ${themes.colors.yellow.lighterYellow};
  }
  text-align: center;
  @media ${({ theme }) => theme.queries.mobile} {
    min-width: 150px;
  }
  @media ${({ theme }) => theme.queries.mobile} {
    width: 130px;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-evenly;
`;
